<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-pencil-alt</v-icon>Update Course Details
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closePanel" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-card flat>
            <v-form>
              <v-text-field
                :error-messages="messages.name"
                v-model="course.name"
                label="Course Name"
                type="text"
                filled
              ></v-text-field>
              <v-layout>
                <v-flex xs6>
                  <v-text-field
                    :error-messages="messages.hours"
                    v-model="course.hours"
                    label="Hours"
                    type="number"
                    class="pr-2"
                    filled
                    :min="0"
                  @keypress="NumbersOnly"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :error-messages="messages.minutes"
                    v-model="course.minutes"
                    label="Minutes"
                    type="number"
                    class="pl-2"
                    filled
                    :min="0"
                    @keypress="NumbersOnly"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-textarea
                v-model="course.description"
                label="Description"
                hint="Enter a description for this course"
                filled
              ></v-textarea>
              <v-combobox
                v-model="course.topics"
                :search-input.sync="search"
                multiple
                label="Tags"
                append-icon
                chips
                deletable-chips
                item-text="tag"
                item-value="id"
                class="tag-input"
                filled
              ></v-combobox>
              <v-select
                v-model="course.channels"
                :items="channels"
                item-text="name"
                item-value="id"
                label="Playlists"
                multiple
                chips
                hint="Assign course to channels"
                persistent-hint
                attach
                filled
              ></v-select>
              <drop-zone
                :type="type"
                :accepted="accepted"
                :image.sync="thumbnail"
                :dropzone-id="'course_thumbnail'"
                class="mt-5"
              ></drop-zone>
              <label
                v-if="messages.s3_url"
                :error-messages="messages.s3_url"
                class="v-messages theme--light error--text"
                >{{ messages.s3_url[0] }}
              </label>
              <p class="block text-left mt-4 caption">
                Max upload filesize: 10MB <br />
                Accepted file formats: png, jpg
              </p>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="primary" @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" class="ml-2" @click="updateCourse"
          >Update</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import courseAPI from '@/api/course.js';
import channelAPI from '@/api/channel.js';
import DropZone from '@/components/global/Dropzone';
import thumbSizes from '@/utils/thumbs.js';

export default {
  name: 'EditCourse',
  components: {
    DropZone,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    params: {
      type: String,
      default: '',
    },
    courseManager: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type: 'thumbnail',
      accepted: 'image/jpg,image/jpeg,image/png',
      search: '',
      messages: {},
      course: {},
      channels: [],
      valid: true,
      loading: false,
      successMessage: 'Course Successfully Updated.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      waitMessage: 'Please wait, we are uploading your image.',
    };
  },
  computed: {
    thumbnail() {
      return this.course.hasOwnProperty('thumbnail')
        ? this.course.thumbnail.data
        : null;
    },
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    },
    selectedChannels() {
      return this.course.channels.data.map((x) => {
        return x.id;
      });
    },
    selectedTopics() {
      return this.course.topics.data.map((x) => {
        return x.tag;
      });
    },
  },
  mounted() {
    this.$store.dispatch('setS3Uploading', false);
    this.getCourse(this.id);
    this.getChannels();
    this.setEventBus();
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    getCourse(id) {
      courseAPI
        .getCourse(id, '?include=channels,thumbnail,topics')
        .then((response) => {
          this.course = response.data.data;
          this.course.channels = this.selectedChannels;
          this.course.topics = this.selectedTopics;
          this.$store.dispatch('setDropzoneLoaded', { id: 'course_thumbnail', value: true });
        });
    },
    updateCourse() {
      this.loading = true;
      if (this.$store.getters.s3Url !== null && this.course.thumbnail.data.url !== this.$store.getters.s3Url) {
        this.$snotify.info(this.waitMessage);
      }
      courseAPI
        .updateCourse(
          this.id,
          this.course,
          this.$store.getters.s3Url,
          this.$store.getters.fileDetails
        )
        .then((resp) => {
          this.closePanel();
          if (this.courseManager) {
            this.$store.dispatch('setCourse', resp.data.data);
            this.$store.dispatch(
              'setCourseMaterials',
              response.data.data.assets.data
            );
          }
          EventBus.$emit('COURSES_UPDATED', this.params);
          EventBus.$emit('COURSE_UPDATED', resp.data.data);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getChannels() {
      channelAPI.getChannels('').then((response) => {
        this.channels = response.data.data;
      });
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode == 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setEventBus() {
      EventBus.$on("FILE_UPLOADED",() => {
        this.$delete(this.messages, "s3_url");
      })
    },
  },
};
</script>
